import { get_el } from 'js/utils';
import Hooks from 'classes/Hooks';

export default class Posts_Nav {

    constructor(container){

        this.container = get_el(container);

        this.hooks = new Hooks([
            'nav_select',
            'update_start',
            'update',
        ])

        this.update_state = 0;

        this.init_groups();
        this.init_nav();
        this.init_initial_state();
        this.init_nav_all();
    }

    init_groups(){
        
        this.groups = {};

        this.container.querySelectorAll('.nav').forEach(nav=>{

            const taxonomy = nav.dataset.taxonomy;
            if( !taxonomy ) return;

            if( !this.groups[taxonomy] ) {
                this.groups[taxonomy] = {
                    current: null,
                    els: [],
                };
            }

            this.groups[taxonomy].els.push(nav);
        })
    }

    init_nav(){
        
        for( const taxonomy in this.groups ) {

            const group = this.groups[taxonomy];
            
            group.els.forEach(nav=>{

                nav.addEventListener('click', ()=>{

                    if( group.current ) {
                        group.current.classList.remove('current')
                    }

                    if( group.current === nav ) {
                        group.current = null;
                        return this.update();
                    }

                    group.current = nav;
                    nav.classList.add('current')
                    
                    this.hooks.do('nav_select', nav)

                    this.update();
                })
            })
        }

    }

    init_initial_state(){
        for( const taxonomy in this.groups ) {
            const group = this.groups[taxonomy];
            group.els.forEach(nav=>{
                if( nav.classList.contains('current') ) {
                    group.current = nav;
                }
            })
        }
    }

    init_nav_all(){
        
        const btn = this.container.querySelector('.nav_all');
        if( !btn ) return;

        this.all_btn = btn;

        if( !this.has_value() ) {
            btn.classList.add('current')
        }
        
        const unselect_others = ()=>{
            for( const taxonomy in this.groups ) {
                const group = this.groups[taxonomy];
                if( group.current ) {
                    group.current.classList.remove('current');
                    group.current = null;
                }
            }
        }

        this.hooks.add('nav_select', ()=>{
            btn.classList.remove('current');
        })

        btn.addEventListener('click', ()=>{
            unselect_others();
            btn.classList.add('current');
            this.update();
        })
    }
    
    update(){
        
        if( !this.update_state ) {
            this.update_state = 1;
            this.hooks.do('update_start');
        }
        
        if( this.update_debounce ) clearTimeout(this.update_debounce);

        this.update_debounce = setTimeout(()=>{
            this.hooks.do('update');
            this.update_state = 0;
        }, 800)

    }

    get_value(){

        if( this.all_btn.classList.contains('current') ) {
            return 'all';
        } 
        
        const value = {};

        for( const taxonomy in this.groups ) {
            const group = this.groups[taxonomy];
            if( !group.current ) continue;
            value[taxonomy] = group.current.dataset.term;
        }

        return value;
    }

    has_value(){
        for( const taxonomy in this.groups ) {
            const group = this.groups[taxonomy];
            if( group.current ) {
                return true;
            }
        }
        return false;
    }
    
}